export default __webpack_public_path__ + "static/media/Prototyping_Tool.df76e89b.jpg";